export const fetching = ({ fetching }) => fetching;
export const mailTo = ({ mailTo }) => mailTo;
export const brands = ({ brands }) => brands;
export const models = ({ models }) => models;
export const years = ({ years }) =>
    years.map((year) => ({ id: year, text: year.toString() }));
export const generations = ({ generations }) => generations;
export const bodies = ({ bodies }) => bodies;
export const gears = ({ gears }) => gears;
export const drives = ({ drives }) => drives;
export const engines = ({ engines }) => engines;
export const modifications = ({ modifications }) => modifications;
export const colors = ({ colors }) => colors;
export const wheels = ({ wheels }) => wheels;
export const states = ({ states }) => states;
export const pts = ({ pts }) => pts;
export const regions = ({ regions }) => regions;
export const modification = ({ modification }) => modification;
